// src/utils/portfolioMigration.js
import { doc, collection, getDocs,  deleteDoc, writeBatch } from 'firebase/firestore';
import { db } from '../services/firebase/config';

export async function migratePortfolioData(userEmail, portfolioId) {
  if (!userEmail || !portfolioId) {
    throw new Error('User email and portfolio ID are required');
  }

  try {
    const userDoc = doc(db, 'users', userEmail);
    const portfolioDoc = doc(userDoc, 'portfolios', portfolioId);

    // 1. Mevcut positions verilerini oku
    const oldPositionsRef = collection(userDoc, 'positions');
    const oldPositionsSnapshot = await getDocs(oldPositionsRef);
    
    // 2. Yeni positions koleksiyonuna taşı
    const batch = writeBatch(db);
    const newPositionsPromises = oldPositionsSnapshot.docs.map(docSnapshot => {
      const positionRef = doc(portfolioDoc, 'positions', docSnapshot.id);
      batch.set(positionRef, docSnapshot.data());
      return docSnapshot.id;
    });

    // 3. Mevcut portfolio verilerini oku
    const oldPortfolioRef = collection(userDoc, 'portfolio');
    const oldPortfolioSnapshot = await getDocs(oldPortfolioRef);
    
    // 4. Yeni portfolio koleksiyonuna taşı
    const newPortfolioPromises = oldPortfolioSnapshot.docs.map(docSnapshot => {
      const portfolioItemRef = doc(portfolioDoc, 'portfolio', docSnapshot.id);
      batch.set(portfolioItemRef, docSnapshot.data());
      return docSnapshot.id;
    });

    // 5. Tüm taşıma işlemlerinin tamamlanmasını bekle
    // Batch'i commit et
    await batch.commit();

    const migratedPositions = newPositionsPromises;
    const migratedPortfolio = newPortfolioPromises;

    // 6. Eski verileri sil
    const deletePositionsPromises = oldPositionsSnapshot.docs.map(doc => 
      deleteDoc(doc.ref)
    );
    const deletePortfolioPromises = oldPortfolioSnapshot.docs.map(doc => 
      deleteDoc(doc.ref)
    );

    await Promise.all([
      ...deletePositionsPromises,
      ...deletePortfolioPromises
    ]);

    return {
      success: true,
      migratedPositions: migratedPositions.length,
      migratedPortfolio: migratedPortfolio.length
    };

  } catch (error) {
    console.error('Migration error:', error);
    throw new Error(`Migration failed: ${error.message}`);
  }
}